import { Avatar, Box, Grid2, QuoteFillIcon } from "components";
import { useFormContext, useWatch } from "react-hook-form";
import { useAppSelector } from "store/store";
import { WebsiteDetails } from "../types";

const QuoteSection = () => {
  const form = useFormContext<WebsiteDetails>();

  const croppedQuoteImage = useAppSelector(
    (state) => state?.myWebsite?.croppedQuoteImage,
  );

  const focusedField = useAppSelector(
    (state) => state?.myWebsite?.focusedField,
  );

  const quote = useWatch({
    control: form.control,
    name: "websiteSection.quotes",
  });

  return (
    <Grid2
      container
      display={"flex"}
      width={"100%"}
      maxWidth={{ xs: "100vw", md: "1192px" }}
      spacing={5}
    >
      <Grid2
        size={12}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <QuoteFillIcon />
      </Grid2>
      <Grid2
        size={12}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Box
          color="#ECECEC"
          lineHeight={"normal"}
          textAlign={"center"}
          width={{ xs: "90%", md: "70%" }}
          fontSize={{ xs: 20, md: 32 }}
          borderRadius={
            focusedField === "websiteSection.quotes.quotes" ? 2 : undefined
          }
          border={
            focusedField === "websiteSection.quotes.quotes"
              ? "2px solid #007bff"
              : undefined
          }
        >
          {quote?.quotes ||
            `You get recessions, you have stock market declines. If you don’t understand that’s going to happen, then you’re not ready, you won’t do well in the markets.`}
        </Box>
      </Grid2>
      <Grid2
        size={12}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={1}
        flexDirection={"column"}
      >
        <Avatar
          sx={{ border: "solid 1px var(--grey-100)" }}
          src={
            croppedQuoteImage ||
            (quote?.quoteOwnerUrl as string) ||
            "https://bostonglobe-prod.cdn.arcpublishing.com/resizer/v2/6RBCDUBIGUI6NNXSMTE4NPM4AE.jpg?auth=3ef6612554f7e0d3cb389971e715ded2e9b62a1dfde0fe7beba72292c68fb7f7&width=1440"
          }
        />
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
        >
          <Box
            color="#ECECEC"
            fontStyle={"italic"}
            borderRadius={
              focusedField === "websiteSection.quotes.quoteOwnerName"
                ? 2
                : undefined
            }
            border={
              focusedField === "websiteSection.quotes.quoteOwnerName"
                ? "2px solid #007bff"
                : undefined
            }
          >
            {quote?.quoteOwnerName || "Peter Lynch"}
          </Box>
          <Box
            color="#9AA4B2"
            fontStyle={"italic"}
            fontSize={12}
            borderRadius={
              focusedField === "websiteSection.quotes.quoteOwnerDesignation"
                ? 2
                : undefined
            }
            border={
              focusedField === "websiteSection.quotes.quoteOwnerDesignation"
                ? "2px solid #007bff"
                : undefined
            }
          >
            Owner,{" "}
            {quote?.quoteOwnerDesignation || "Chairman of the Lynch Foundation"}
          </Box>
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default QuoteSection;
